<template>
  <div class="asd-form-section">
    <div class="section-title">
      <h5>
        <i class="fas fa-envelope"></i>
        Detail šablony
      </h5>
      <div class="section-title-controls">
        <ActiveButton
          class="asd-btn-confirm asd-btn-single-icon"
          :click="save"
        >
          <i class="fas fa-save"></i>
        </ActiveButton>
      </div>
    </div>
    <div class="asd-form">
      <div class="grid">
        <div>
          <label for="name">Název</label>
          <input id="name"
                 v-model="data.name"
                 type="text"
                 class="asd-input"
          >
        </div>
        <div>
          <label for="contentType">Typ obsahu</label>
          <Multiselect
            id="contentType"
            v-model="data.contentType"
            :max="1"
            label="label"
            trackBy="key"
            valueByPath="key"
            :options="contentTypes"
            :returnAsSingle="true"
            :allowEmpty="false"
          >
          </Multiselect>
        </div>
      </div>
      <label for="name">Obsah šablony</label>
      <textarea v-model="data.template" class="asd-input" style="min-height: 50vh">
      </textarea>
    </div>
  </div>
</template>

<script>
import ActiveButton from 'CORE/components/form/active-button'
import EventBus from 'CORE/bus'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import contentTypes from 'ENUMS/template-content-types'

export default {
    name: 'SettingsComapnyTemplateForm',
    components: {
        ActiveButton,
        Multiselect,
    },
    props: {
        templateId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            data: {},
        }
    },
    computed: {
        contentTypes() {
            return contentTypes
        },
    },
    mounted() {
        this.data = this.$store.getters.companyTemplateById(this.templateId)
    },
    methods: {
        async save() {
            try {
                await this.$store.dispatch('companyTemplatesSave', this.data)
                await this.$store.dispatch('companyTemplatesLoad')
                EventBus.$emit('FLASH_OK', { message: 'Uloženo' })
                this.$emit('done')
            } catch (e) {
                EventBus.$emit('FLASH_ERROR', e)
            }
        },
    },
}
</script>
